import { NgStyle } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CmsItem } from '@coin/shared/cms/util';
import { V2NumberInputComponent, V2TextInputComponent } from '@coin/shared/core/ui-storybook';
import { TranslateModule } from '@ngx-translate/core';
import { HtmlEditorComponent } from '../../shared/html-editor/html-editor.component';

@Component({
  selector: 'coin-gmm-text-block',
  templateUrl: './text-block.component.html',
  styleUrls: ['./text-block.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatFormFieldModule,
    TranslateModule,
    FormsModule,
    NgStyle,
    V2NumberInputComponent,
    HtmlEditorComponent,
    V2TextInputComponent
  ]
})
export class TextBlockComponent {
  @Input() item: CmsItem<'text-block'>;
  @Input() contentEdit = false;

  public get adjustedText(): string {
    return this.item?.text?.replaceAll(/&nbsp;(?!<)|(?<!>)&nbsp;/g, ' ');
  }
}
